export default "__VITE_ASSET__2$4D8pUt__"